'use client';

import React from 'react';
import { Tabs } from '@/components/common/Tabs/Tabs';
import styles from '@app/(bank)/login/index.module.scss';
import { Tab } from '@/components/common/Tab/Tab';
import { LoginForm } from '@/components/login-form/LoginForm';
import { RegisterForm } from '@/components/register-form/RegisterForm';
import { useMobileView } from '@/hooks/useIsInMobileView';
import { useTranslation } from '@app/i18n/useTranslationClient';
import { translate } from '@/translations/static/staticTranslations';
import { useRouter } from 'next/navigation';
import { ILoginFormSchemaResponse } from '@/hooks/api/fetchLoginFormSchema/useLoginFormSchema.interfaces';
import { IRegistrationFormSchemaResponse } from '@/hooks/api/fetchRegistrationFormSchema/useRegistrationFormSchema.interfaces';

interface ILoginAndRegister {
    loginSchema: ILoginFormSchemaResponse;
    registrationSchema: IRegistrationFormSchemaResponse;
    onNextStep?(): void;
}

export const LoginAndRegister: React.FC<ILoginAndRegister> = (props) => {
    const isInMobileView = useMobileView();
    const {
        t,
        i18n: { language },
    } = useTranslation();
    const router = useRouter();

    const onLogin = () => {
        const accountPath: string = translate(language, 'routes.account');

        router.push(accountPath);
        router.refresh();
    };

    const loginFormProps = {
        onNextStep: props.onNextStep,
        schema: props.loginSchema,
        onLogin,
    };

    const registerFormProps = {
        schema: props.registrationSchema,
    };

    if (isInMobileView) {
        return (
            <Tabs
                tabClasses={{
                    tab: styles.tab,
                    activeHeader: styles.tabActive,
                }}>
                <Tab title={t('translations.login.form.loginTitle')}>
                    <div className={styles.contentLogin}>
                        <LoginForm {...loginFormProps} shouldDisplayHeader={false} />
                    </div>
                </Tab>
                <Tab title={t('translations.register.form.registerTitle')}>
                    <div className={styles.contentRegister}>
                        <RegisterForm {...registerFormProps} shouldDisplayHeader={false} />
                    </div>
                </Tab>
            </Tabs>
        );
    }

    return (
        <div className={styles.contentForms}>
            <div className={styles.contentLogin}>
                <LoginForm {...loginFormProps} shouldDisplayHeader={true} />
            </div>
            <div className={styles.contentRegister}>
                <RegisterForm {...registerFormProps} shouldDisplayHeader={true} />
            </div>
        </div>
    );
};
